module.exports = __webpack_public_path__ + "static/media/sberTips.9650a86f.svg";